import { withInstall } from '../../../../utils/with-install'
import DistrictLayer from './DistrictLayer.vue'

export const ElAmapLayerDistrict = withInstall(DistrictLayer)
export default ElAmapLayerDistrict
